export const config = {
  appId: 'ef48ebca-b1a2-4beb-b124-ceeb79d889dc',
  redirectUri: 'https://encontech.azurewebsites.net/',
  scopes: [
    'user.read',
    'mailboxsettings.read',
    'calendars.readwrite'
  ]
};